import React, { useContext, useEffect } from 'react'
import HomeNavBar from '../Component/HomeComponent/HomeNavBar'
import { HrStorage } from '../Context/HrStore'
import Footer from '../Component/Footer'
import HomeBanner from '../Component/HomeComponent/HomeBanner'
import OurServices from '../Component/HomeComponent/OurServices'
import WhyChooseUs from '../Component/HomeComponent/WhyChooseUs'
import HomeTestimonial from '../Component/HomeComponent/HomeTestimonial'
import OurBlogs from '../Component/HomeComponent/OurBlogs'
import EventsSection from '../Component/HomeComponent/EventsSection'
import HomeContact from '../Component/HomeComponent/HomeContact'
import { Helmet } from 'react-helmet'
import HomeHeroSection from '../Component/HomeComponent/HomeHeroSection'
import Challenges from '../Component/HomeComponent/Challenges'
import IndustryConsulting from '../Component/HomeComponent/IndustryConsulting'
import MeasurableOutcomes from '../Component/HomeComponent/MeasurableOutcomes'
import { motion } from 'framer-motion'
import homeOurServiceCta from '../Assest/cards/TopRecruitmentAgency.avif'
import { useNavigate } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { GlobalEnquiryContext } from '../App'
import CTAButton from '../Component/CTAButton'

const HomePage = () => {
    let { setactive } = useContext(HrStorage)
    const { openEnquiry } = useContext(GlobalEnquiryContext);
    const navigate = useNavigate();
    useEffect(() => {
        setactive('home')
    }, [])
    return (
        <div className='homebg' >
            <Helmet>
                <title>End-to-End HR Consulting Services | Merida HR Consulting</title>
                <meta name="description" content="Reliable HR consulting services company in Bangalore offering staffing, payroll, recruitment outsourcing, compliance, and workforce solutions for businesses." />
                <meta name="keywords" content="HR Consulting Services, HR consulting company, HR consulting firms, HR consulting agency, HR consulting services company, best HR consulting company, Top HR consulting firms, Top recruitment Agency, HR consulting services in Bangalore, Best HR consultancy in Bangalore, HR consulting company in Bangalore, HR consulting firms in Bangalore, HR consulting agency in Bangalore, HR consulting services in Jayanagar, HR consulting company in Jayanagar, staffing solutions company, staffing services company, recruitment consulting firm, workforce management company, HR outsourcing company, RPO services company, payroll outsourcing company, IT staffing company, non IT staffing company, executive search firms, bulk hiring services company, GCC hiring company, talent acquisition consulting company, strategic HR consulting services, corporate HR solutions company, manpower consulting firms, recruitment agency Bangalore, hiring consultancy company, staffing agency near me, HR solutions company near me, best staffing company in Bangalore, top recruitment firms in Bangalore, HR outsourcing services Bangalore, recruitment process outsourcing company, permanent staffing services company, contract staffing services company, HR compliance services company, payroll management company, statutory compliance consulting services, remote hiring services company, AI recruitment solutions company, best HR consulting services company in Bangalore for startups, top staffing and recruitment company for IT hiring, reliable HR outsourcing company in Bangalore, end-to-end recruitment process outsourcing services, top payroll outsourcing company for SMEs, bulk hiring consulting firm for fast growing companies, executive search firm for leadership hiring, HR consulting agency for GCC hiring in Bangalore, AI powered recruitment consulting services, HR compliance and payroll management services company, contract staffing company for businesses, strategic workforce planning consulting services, scalable recruitment solutions for startups and enterprises, best recruitment agency in Bangalore for tech companies, staffing company with payroll and compliance solutions, outsourced HR services company for growing businesses, talent acquisition company for rapid expansion hiring, top HR and staffing company near Jayanagar Bangalore, high volume hiring services company Bangalore" />
                <link rel="canonical" href="https://www.meridahr.com/" />
                {/* Open Graph */}
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="End-to-End HR Consulting Services | Merida HR Consulting"
                />
                <meta
                    property="og:description"
                    content="Reliable HR consulting services company in Bangalore offering staffing, payroll, recruitment outsourcing, compliance, and workforce solutions."
                />
                <meta property="og:url" content="https://www.meridahr.com/" />
                <meta
                    property="og:image"
                    content="https://www.meridahr.com/MeridaConsultancyLogo.png"
                />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta
                    name="twitter:title"
                    content="End-to-End HR Consulting Services | Merida HR Consulting"
                />
                <meta
                    name="twitter:description"
                    content="Reliable HR consulting services company in Bangalore."
                />
                <meta
                    name="twitter:image"
                    content="https://www.meridahr.com/MeridaConsultancyLogo.png"
                />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "WebSite",

                        "@id": "https://www.meridahr.com/#website",

                        url: "https://www.meridahr.com/",

                        name: "Merida HR Consulting",

                        publisher: {
                            "@id": "https://www.meridahr.com/#organization"
                        },

                        inLanguage: "en-US",

                        potentialAction: {
                            "@type": "SearchAction",

                            target:
                                "https://www.meridahr.com/blogs?q={search_term_string}",

                            "query-input":
                                "required name=search_term_string"
                        }
                    })}
                </script>
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",

                        "@type": "Organization",

                        "@id": "https://www.meridahr.com/#organization",

                        name: "Merida HR Consulting",

                        url: "https://www.meridahr.com/",

                        logo: {
                            "@type": "ImageObject",

                            "@id": "https://www.meridahr.com/#logo",

                            url:
                                "https://www.meridahr.com/MeridaConsultancyLogo.png",

                            contentUrl:
                                "https://www.meridahr.com/MeridaConsultancyLogo.png",

                            caption: "Merida HR Consulting"
                        },

                        image: {
                            "@id": "https://www.meridahr.com/#logo"
                        },

                        telephone: "+918904599283",

                        email: "info@meridahr.com",

                        sameAs: [
                "https://www.facebook.com/MERIDAHRCONSULTING/",
                "https://www.linkedin.com/company/95719869/admin/dashboard/",
                "https://www.instagram.com/meridahrconsultancy/?hl=en",
                "https://www.youtube.com/@meridahrconsultancy5069"
            ],

                        contactPoint: [
                            {
                                "@type": "ContactPoint",

                                telephone: "+91-8904599283",

                                contactType: "Customer Service",

                                email: "meridahrconsulting@gmail.com",

                                areaServed: "IN",

                                availableLanguage: [
                                    "English"
                                ]
                            }
                        ]
                    })}
                </script>
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "WebPage",

                        "@id": "https://www.meridahr.com/",

                        url: "https://www.meridahr.com/",

                        name: "End-to-End HR Consulting Services | Merida HR Consulting",

                        description:
                            "Reliable HR consulting services company in Bangalore offering staffing, payroll, recruitment outsourcing, compliance, and workforce solutions for businesses.",

                        isPartOf: {
                            "@id": "https://www.meridahr.com/#website"
                        },

                        about: {
                            "@id": "https://www.meridahr.com/#organization"
                        },

                        publisher: {
                            "@id": "https://www.meridahr.com/#organization"
                        },

                        primaryImageOfPage: {
                            "@id": "https://www.meridahr.com/#primaryimage"
                        },

                        image: {
                            "@id": "https://www.meridahr.com/#primaryimage"
                        },

                        breadcrumb: {
                            "@id": "https://www.meridahr.com/#breadcrumb"
                        },

                        inLanguage: "en-US",

                        potentialAction: {
                            "@type": "ReadAction",
                            target: "https://www.meridahr.com/"
                        }
                    })}
                </script>

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",

                        "@type": "ImageObject",

                        "@id": "https://www.meridahr.com/#primaryimage",

                        inLanguage: "en-US",

                        url:
                            "https://www.meridahr.com/images/home-banner.webp",

                        contentUrl:
                            "https://www.meridahr.com/images/home-banner.webp",

                        caption:
                            "Merida HR Consulting - AI Powered HR Consulting & Staffing Solutions"
                    })}
                </script>

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",

                        "@type": "BreadcrumbList",

                        "@id": "https://www.meridahr.com/#breadcrumb",

                        itemListElement: [
                            {
                                "@type": "ListItem",
                                position: 1,
                                name: "Home",
                                item: "https://www.meridahr.com/"
                            }
                        ]
                    })}
                </script>

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",

                        "@type": "RecruitmentAgency",

                        "@id": "https://www.meridahr.com/#recruitmentagency",

                        name: "Merida HR Consulting",

                        url: "https://www.meridahr.com/",

                        parentOrganization: {
                            "@id": "https://www.meridahr.com/#organization"
                        },

                        image: {
                            "@id": "https://www.meridahr.com/#logo"
                        },

                        telephone: "+91-8904599282",

                        email: "info@meridahr.com",

                      

                        address: {
                            "@type": "PostalAddress",
                            streetAddress: "1st Floor, 334/28, 14th Cross Rd, 2nd Block, Jayanagar",
                            addressLocality: "Bengaluru",
                            addressRegion: "Karnataka",
                            postalCode: "560011",
                            addressCountry: "IN"
                        },

                        aggregateRating: {
                            "@type": "AggregateRating",
                            ratingValue: "4.8",
                            reviewCount: "124"
                        },

                        review: [
                            {
                                "@type": "Review",
                                author: {
                                    "@type": "Person",
                                    name: "Simon Árpád"
                                },
                                reviewRating: {
                                    "@type": "Rating",
                                    ratingValue: "5"
                                },
                                reviewBody:
                                    "Excellent HR consulting and recruitment services. Merida helped us scale our technical software team rapidly."
                            }
                        ]
                    })}
                </script>
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "RecruitmentAgency",
                        "name": "Merida HR Consulting",
                        "image": "https://www.meridahr.com/MeridaConsultancyLogo.png",
                        "url": "https://www.meridahr.com/",
                        "telephone": "+91-8904599282",
                        "address": {
                            "@type": "PostalAddress",
                            "streetAddress": "1st Floor, 334/28, 14th Cross Rd, 2nd Block, Jayanagar",
                            "addressLocality": "Bengaluru",
                            "addressRegion": "Karnataka",
                            "postalCode": "560011",
                            "addressCountry": "IN"
                        },
                        "priceRange": "$$",
                        "aggregateRating": {
                            "@type": "AggregateRating",
                            "ratingValue": "4.8",
                            "reviewCount": "124"
                        },
                        "review": [
                            {
                                "@type": "Review",
                                "author": {
                                    "@type": "Person",
                                    "name": "Simon Árpád"
                                },
                                "reviewRating": {
                                    "@type": "Rating",
                                    "ratingValue": "5"
                                },
                                "reviewBody": "Excellent HR consulting and recruitment services. Merida helped us scale our technical software team rapidly."
                            }
                        ]
                    })}
                </script>
            </Helmet>
            <div className="absolute w-full top-0 z-50">
                <HomeNavBar />
            </div>
            {/* <HomeBanner /> */}
            <HomeHeroSection />
            <Challenges />
            <OurServices />
            <div className="bg-white pb-24">
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                    className="container mx-auto px-6"
                >
                    <div className="w-full overflow-hidden rounded-[2.5rem] relative">
                        <img
                            src={homeOurServiceCta}
                            alt="Our Services CTA"
                            className="w-full h-auto object-cover"
                        />
                        <div className="absolute inset-0 flex items-end justify-center pb-10 bg-black/5">
                            <CTAButton
                                text="Discuss Hiring Challenges"
                                type="secondary"
                                onClick={() => openEnquiry("Discuss Your Hiring Challenges", [])}
                            />
                        </div>
                    </div>
                </motion.div>
            </div>
            <WhyChooseUs />
            <div className="my-16 flex justify-center">
                <CTAButton
                    text="Discuss Your HR Needs"
                    type="secondary"
                    onClick={() => openEnquiry("Discuss HR Needs (Home Page)")}
                />
            </div>
            <IndustryConsulting />
            <MeasurableOutcomes />
            <div className="my-16 flex justify-center">
                <CTAButton
                    text="Request HR Consultation"
                    type="secondary"
                    onClick={() => openEnquiry("Consultation Request (Home Page)")}
                />
            </div>
            <HomeTestimonial />
            <OurBlogs />
            <EventsSection />
            <HomeContact />


        </div>
    )
}

export default HomePage